const nodeObserver = new MutationObserver((mutations) => {
  if (mutations[0].attributeName === 'class') {
    updateCartCounter();
  }
})

function productFn() {
  const node = document.querySelector('.slidecarthq-overlay');
  nodeObserver.observe(node, {
    attributes: true,
  });
}

function updateCartCounter() {
  fetch(window.Shopify.routes.root + 'cart.js', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  })
  .then(response => response.json())
  .then(data => {
    const node = document.querySelector('.header__menu-link--cart__count');
    if (node)
      node.innerHTML = data['item_count'];
    else {
      const newNode = document.createElement('SPAN');
      newNode.classList.add('header__menu-link--cart__count');
      newNode.innerHTML = data['item_count'];
      const buttons = document.querySelectorAll('.header__menu-link--cart__span');
      buttons[buttons.length - 1].appendChild(newNode);
    }
    if (data['item_count'] == 0 && node) {
      node.remove();
    }
    const priceNode = document.querySelector('.header__menu-link--cart__text__total');
    if (priceNode) {
      priceNode.textContent = window.BOLD.common.Shopify.formatMoney(data.total_price);
    }
  });
}

const documentObserver = new MutationObserver((mutations) => {
  mutations.forEach(mutation => {
    if (mutation.type === 'childList') {
      mutation.addedNodes.forEach(node => {
        if (node.id == 'slidecarthq') {
          setTimeout(() => productFn(), 1000);
        }
      })
    }
  })
}).observe(document.body, {
  childList: true
})

document.addEventListener('DOMContentLoaded', () => {
  const params = new URLSearchParams(window.location.search);
  if (!params.has('variant')) {
    document.querySelector('.product-form__input.fieldset.options > .product-main__option > label')?.click();
  }
})

